<template>
  <div class="videoUpload" >
    <el-upload
      v-if="!loading"
      action="/sunrise-gateway/oss/ossUpload"
      :show-file-list="false"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload"
      :on-progress="progressInfo"
      :on-error="errorInfo"
      @click.stop>
      <!-- < -->
      <div v-if="uploadUrl" class="videoDiv">
        <video v-if="isVideo" :src="uploadUrl" class="videoSizeClass" controls="controls">
          您的浏览器不支持视频播放
        </video>
        <img v-else :src="uploadUrl" class="imgSizeClass">
        <i class="el-icon-error errorClass" @click.stop="closeVideo"></i>
      </div>
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <el-progress type="circle" v-if="loading" :percentage="percentage"></el-progress>
  </div>
</template>

<script>
export default {
  props: {
    value:{

    },
    isVideo: {
      type: Boolean,
      default: false
    },

    //宽度设置
    width:{
        type:Number,
        default: 240
    },
    //高度设置
    height:{
        type:Number,
        default: 240
    },
    imgWidthAndHeight:{
        type:Number,
        default: 600
    }
  },
  data(){
    return {
      uploadUrl:null,
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      loading:false,
      percentage:0,
    }
  },
  model: {
    prop: 'value',
    event: 'valChange'
  },
  watch: {
    value(newVal,oldVal){
      this.uploadUrl = newVal
    }
  },
  methods: {
    progressInfo(event, file, fileList){
      this.percentage = parseInt(event.percent)
      this.loading = true
      console.log(event, )
    },
    errorInfo(){
      this.loading = false
    },

    handleAvatarSuccess(file){
      this.loading = false
      this.uploadUrl = file.data[0]
      this.$emit('valChange', file.data[0])
    },
    beforeAvatarUpload(file){
      if(this.isVideo){
         const fileType = (file.type.indexOf('mp4') != -1);
         const sizeInfo = file.size / 1024 / 1024 < 50;
        if(!fileType) {
          this.$message.error('请上传格式为MP4的视频!');
        }else if(!sizeInfo) {
          this.$message.error('上传视频大小不能超过 50MB!');
        }
        return fileType && sizeInfo;
      }else{
        const isImage = (file.type.indexOf('png') != -1 || file.type.indexOf('jpeg') != -1 || file.type.indexOf('jpg') != -1);
        const imgSize = file.size / 1024 / 1024;
        if(!isImage){
            this.$message.warning('请上传格式为png、jpg的图片')
        }else if(!(imgSize>0 && imgSize<1)){
            this.$message.warning(`请上传大小不超过1M的图片`)
        }
        if(this.imgWidthAndHeight){
            var that = this
            var isSize = new Promise(function(resolve, reject) {
                let _URL = window.URL || window.webkitURL;         
                let img = new Image();
                img.onload = function() {
                let width = img.width;//获取图片的宽
                let height = img.height;//获取图片的高
                // let valid = width*height*4;
                console.log(width,that.imgWidthAndHeight)
                width == that.imgWidthAndHeight ? resolve() : reject();
                }
                img.src = _URL.createObjectURL(file);
            }).then(() => {
                return file;
            }, () => {
                this.$message.error(`请上传${this.imgWidthAndHeight}px*${this.imgWidthAndHeight}px图片！`);
                return Promise.reject();
            });
        }else{
            var isSize = true
        }
        let bool = isImage && (imgSize>0 && imgSize<1)&&isSize;
        return bool;
      }
    },
    closeVideo(){
      this.uploadUrl = null
      this.$emit('valChange', null)
    },
  },
  mounted(){

  },
}
</script>

<style lang="less">
.videoUpload{
    .avatar-uploader-icon {
      border: 1px solid #ddd;
      width: 180px;
      height: 180px;
      line-height: 180px;
      font-size: 30px;
    }

    .el-upload--picture-card {
      width: 180px;
      height: 180px;
    }

    .el-upload-list--picture-card .el-upload-list__item {
      width: 180px;
      height: 180px;
    }
    .videoSizeClass{
      height: 180px;
    }
    .imgSizeClass{
      width: 180px;
      height: 180px;
    }
    .videoDiv{
      position: relative;
     
      .errorClass{
        position: absolute;
        right: 0;
        top: 0;
        font-size: 20px;
        color:#F56C6C
      }
    }
}
</style>